import { Component, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { RestaurantBasicInfoStorage } from 'src/app/appStorage/restaurant-basic-info.storage';
import { NumberUtility } from 'src/app/appUtilities/number.utility';
import { CheckoutResolver } from '../checkout.resolver';


@Component({
  selector: 'app-payment-mode',
  templateUrl: './payment-mode.component.html',
  styleUrls: ['./payment-mode.component.scss']
})
export class PaymentModeComponent {
  paymentMethods: any[] = [];
  basicInfo: any;

  stripeProcessingFee: any;


  constructor(
    private _bottomSheetRef: MatBottomSheetRef<PaymentModeComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private infoStorage: RestaurantBasicInfoStorage,
    private checkoutResolver: CheckoutResolver,
    private numberUtility: NumberUtility
  ) {
    this.getProcessingFee();
    this.paymentMethods = this.data.paymentMethods;
    this.getBasicInfo();
  }

  selectMethod(method): void {
    this._bottomSheetRef.dismiss(method);
  }

  /**
* get processing fee 
*/
  getProcessingFee() {
    this.checkoutResolver.stripeProcessingFee.subscribe(res => {
      this.stripeProcessingFee = res;
    });
  }

  /**
  * get basic information
  */
  getBasicInfo(): void {
    this.infoStorage.restaurantBasicInfo.subscribe(res => {
      if (res) {
        this.basicInfo = res;
      }
    });
  }

  /**
   * calculateProcessing Fee
   */
  calculateProcessingFee(paymentMode: string): number {
    return this.checkoutResolver.calculateProcessingFee(this.data.totalAmount, paymentMode, this.stripeProcessingFee);
  } 

}